import styled from 'styled-components'

export const PanelBody = styled.div`
  padding: 18px 36px 50px 36px;
`
